import { getMondayOfWeekDateString } from "helpers/weekScheduleHelper";
export const getInitAllocateRunnerParams = () => {
  return {
    sizePerPage: 10,
    page: -1,
    sort: "-checker_date",
    columnFilter: {
      "filter[week_start_date]": getMondayOfWeekDateString(),
    },
    columnFilterKeep: {},
    keywords: "",
    columnsVisible: {},
    fields: "",
    expand: "hub,route,timeSlot",
    run: false,
  };
};

export const getInitChangeScheduleRunnerParams = () => {
  return {
    sizePerPage: 10,
    page: 1,
    sort: "-checker_date",
    columnFilter: {},
    keywords: "",
    columnsVisible: {},
    fields: "",
    expand: "",
    run: false,
  };
};

export const getInitOrderRunnerDetailParams = () => {
  return {
    sizePerPage: 10,
    page: -1,
    sort: "-checker_date",
    columnFilter: {},
    keywords: "",
    columnsVisible: {},
    fields: "",
    expand: "timeSlot",
  };
};

export const MODE_DETAIL = {
  CREATE: "create",
  UPDATE: "update",
  VIEW: "view",
};
